class ProductPectoDetails extends HTMLElement {
  constructor() {
    super();
    this._onResize = this._onResize.bind(this);
    this._resizeTimer = null;
    this.mql = window.matchMedia('(max-width: 749px)');
  }

  connectedCallback() {
    this.btn = this.querySelector('.description-viewer');
    this.descriptionBox = this.querySelector('.product-features__description');
    this.closeBtn = this.querySelector('.close-btn');

    if (!this.descriptionBox) return;

    this.btn?.addEventListener('click', () => this.toggleDescription());
    this.closeBtn?.addEventListener('click', () => this.toggleDescription());
    
    window.addEventListener('resize', this._onResize);
    
    this.rePositionDescriptionBox();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  _onResize() {
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this.rePositionDescriptionBox();
    }, 100);
  }

  toggleDescription() {
    const isOpen = this.descriptionBox.classList.contains('is-active');
    
    if (!isOpen) {
      document.querySelectorAll('product-pecto-details').forEach(el => el.close());
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.descriptionBox.classList.add('is-active');
  }

  close() {
    if (this.descriptionBox) {
      this.descriptionBox.classList.remove('is-active');
    }
  }

  rePositionDescriptionBox() {
    this.descriptionBox.style.transform = 'translateX(0)';
    let rect = this.descriptionBox.getBoundingClientRect();
    let adjustment = 0;

    if (this.mql.matches) {
      adjustment = rect.right - (rect.width + 16);
      this.descriptionBox.style.width = 'calc(100vw - 32px)';
      this.descriptionBox.style.transform = `translateX(-${adjustment}px)`;

      return;
    }
    
    this.descriptionBox.style.width = '320px';
    rect = this.descriptionBox.getBoundingClientRect();
    const containerRect = document.querySelector('.page-width .product').getBoundingClientRect();
    const gap = 10;

    if (containerRect && rect.right > containerRect.right) {
      adjustment = containerRect.right - rect.right - gap;
    } else if (rect.left < 0) {
      adjustment = Math.abs(rect.left) + gap;
    }

    this.descriptionBox.style.transform = `translateX(${adjustment}px)`;
  }
}

customElements.define('product-pecto-details', ProductPectoDetails);